import Label    from '../../../State/Stores/Captions/Constants/Label';
import Language from '../../../State/Stores/Captions/Constants/Language';

const mapLanguageCodeToLabel = (languageCode: Language): Label => ({
    [Language.ENGLISH]: Label.ENGLISH,
    [Language.FRENCH]: Label.FRENCH,
    [Language.GERMAN]: Label.GERMAN,
    [Language.ITALIAN]: Label.ITALIAN,
    [Language.JAPANESE]: Label.JAPANESE,
    [Language.SPANISH]: Label.SPANISH
})[languageCode];

export default mapLanguageCodeToLabel;